export const DEBTS = {
  DEBTS: 'debts',
  DEBT: 'debt',
};
